'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.createAppnexusHandler = createAppnexusHandler;

var _attributes = require('./attributes');

var _tracking = require('./tracking');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global window */
var getApnQueue = function getApnQueue() {
    var win = window;
    win.apntag = win.apntag || {};
    win.apntag.anq = win.apntag.anq || [];
    return win.apntag.anq;
};

var queueApiCall = function queueApiCall(command) {
    return new _promise2.default(function (resolve) {
        getApnQueue().push(function () {
            command(window.apntag);
            resolve();
        });
    });
};

function createAppnexusHandler(options) {
    // eslint-disable-line import/prefer-default-export
    var prepareTag = options.prepareTag,
        preparePageOptions = options.preparePageOptions;


    var defineTag = function defineTag(node) {
        var placementId = (0, _attributes.getId)(node);
        var nodeDataAttrs = (0, _attributes.getDataAttributes)(node);
        var screensize = window.innerWidth;
        var selectedVariant = selectVariant(nodeDataAttrs);

        if (selectedVariant) {
            node.style.minHeight = selectedVariant.probableHeight + 'px'; // eslint-disable-line no-param-reassign
            defineTagForVariant(selectedVariant, placementId);
        }

        function selectVariant(data) {
            var variants = JSON.parse(data.variants);
            variants.sort(function (a, b) {
                return a.minDisplayWidth < b.minDisplayWidth;
            });

            return variants.reduce(function (previous, variant) {
                return !previous && variant.minDisplayWidth <= screensize ? variant : previous;
            }, undefined);
        }

        function defineTagForVariant(variant, targetId) {
            var tag = {
                targetId: targetId,
                sizes: variant.sizes,
                invCode: variant.invCode,
                keywords: {}
            };

            var finalTag = prepareTag(tag, {
                variant: variant,
                screensize: screensize
            });

            queueApiCall(function (apnTag) {
                return apnTag.defineTag(finalTag);
            });
        }
    };

    var showTag = function showTag(id) {
        queueApiCall(function (apnTag) {
            return apnTag.showTag([id]);
        });
    };

    var onEvent = function onEvent(id, eventHandlerMap) {
        queueApiCall(function (apnTag) {
            return (0, _keys2.default)(eventHandlerMap).forEach(function (eventName) {
                return apnTag.onEvent(eventName, id, eventHandlerMap[eventName]);
            });
        });
    };

    var offEvent = function offEvent(id, eventHandlerMap) {
        queueApiCall(function (apnTag) {
            return (0, _keys2.default)(eventHandlerMap).forEach(function (eventName) {
                return apnTag.offEvent(eventName, id, eventHandlerMap[eventName]);
            });
        });
    };

    var refresh = function refresh(id) {
        queueApiCall(function (apnTag) {
            return apnTag.refresh(id);
        });
    };

    var setPageOptions = function setPageOptions(pageOptions) {
        var normalizedPageOptions = preparePageOptions((0, _extends3.default)({
            disablePsa: true,
            noBidIfUnsold: true
        }, pageOptions));

        queueApiCall(function (apnTag) {
            return apnTag.setPageOpts(normalizedPageOptions);
        });
    };

    var queuedLoadTags = false;
    var loadTags = function loadTags() {
        if (!queuedLoadTags) {
            queuedLoadTags = _promise2.default.resolve().then(function () {
                return queueApiCall(function (apnTag) {
                    return apnTag.loadTags();
                });
            }).then(function () {
                queuedLoadTags = false;
            });
        }

        return queuedLoadTags;
    };

    var fireImpressionTrackers = function fireImpressionTrackers(adObj) {
        return queueApiCall(function (apnTag) {
            return apnTag.fireImpressionTrackers ? apnTag.fireImpressionTrackers(adObj) : (0, _tracking.track)(adObj.native.impressionTrackers);
        });
    };

    return {
        defineTag: defineTag,
        showTag: showTag,
        onEvent: onEvent,
        offEvent: offEvent,
        refresh: refresh,
        setPageOptions: setPageOptions,
        loadTags: loadTags,
        fireImpressionTrackers: fireImpressionTrackers
    };
}
//# sourceMappingURL=appnexus.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ad-renderer/lib/appnexus.js
 ** module id = 463
 ** module chunks = 1
 **/